import axios from 'axios';
import Pagination from '@/domain/pagination.entity';
import Response from '@/domain/response.entity';
import { ContractHistoryType } from '../entity/contract-history-type.enum';

export default class ContractHistoryService {
  public static get(
    businessUnitId: string, contractId: string, type: ContractHistoryType, pagination: Pagination,
  ): Promise<Response> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/contracts/${contractId}/history`, {
      params: {
        page: pagination.page - 1,
        size: pagination.itemsPerPage,
        type,
      },
    })
      .then((response: any) => Response.of(response.data));
  }
}
